import { SelectedConversaton, setSelectedConversation } from "../../../store/slices/conversation.slice";
import phone from "../../../assets/images/icon/Phone-call-msg.svg";
import assign from "../../../assets/images/icon/Assign.svg";
import resolve from "../../../assets/images/icon/Check-circle.svg";
import newContact from "../../../assets/images/icon/New contact.svg";
import download from "../../../assets/images/icon/Download.svg";
import blockNumber from "../../../assets/images/icon/Block number.svg";
import markAsUnread from "../../../assets/images/icon/Mark as unread.svg";
import deleteIcon from "../../../assets/images/icon/Delete.svg";
import { Flex, Image, Popover, Typography } from "antd";
import { AppDispatch, RootState } from "../../../store/store";
import { useDispatch, useSelector } from "react-redux";
import ModalWrapper from "../../generic/modal";
import { useState } from "react";
import { UsersList } from "../didUsers/user.list";
import AddContactModal from "../../Contacts/AddContactModal";
import ExistingContactModal from "../../Contacts/existingContactModal";
import { Contact } from "@data-phone/react-generic/dist/components/Forms/Contacts";
import { RxCrossCircled } from "react-icons/rx";
import { updateConversation } from "../../../hooks/apis/conversations.api";

const { Text } = Typography;
const ImageStyle: React.CSSProperties = {
    width: "28px",
    height: "28px",
    objectFit: "contain",
    objectPosition: "center",
    display: "block",
    margin: "auto"
};
const ContentWrapper: React.CSSProperties = {
    padding: "10px"
};

const PhoneTextStyle: React.CSSProperties = {
    textAlign: "center"
};

const BoxStyle: React.CSSProperties = {
    paddingTop: "10px"
};

const ChatSideBar = ({
    selectedConversation,
}: {
    selectedConversation: SelectedConversaton;
}) => {
    const dispatch: AppDispatch = useDispatch();
    const [isAssignConversation, setIsAssignConversation] = useState(false);
    const [addContactModal, setAddContactModal] = useState(false);
    const [existingContactModal, setExistingContactModal] = useState(false);
    const [editData, setEditData] = useState<Contact | null>(null);

    const { data: conversations } = useSelector((state: RootState) => state.conversation);
    const { data: contacts } = useSelector((state: RootState) => state.contacts);

    let conversationData = conversations.find(conversation => {
        return conversation.id === selectedConversation.conversation_id;
    });

    if (!conversationData) {
        conversationData = {
            id: selectedConversation.conversation_id,
            did: selectedConversation.did,
            participants: selectedConversation.participants,
            type: selectedConversation.type,
            unread: false,
            unread_messages_count: 0,
            last_read_timestamp: new Date().toISOString(),
            resolved: false,
            resolved_at: null,
            assigned_user: null,
            last_message_time: new Date().toISOString(),
            last_message: "",
        };
    }
    const directParticipant = selectedConversation.participants[0];
    const isGroupConversation = selectedConversation.type === "group";


    const MarkAsUnread = (unread: Boolean) => {
        if (unread) {
            dispatch(setSelectedConversation(null));
        }
        updateConversation({
            did: selectedConversation.did,
            conversation_id: selectedConversation.conversation_id,
            unread: unread ? true : false,
            ...(unread ? {} : { last_read_timestamp: new Date().toISOString() }),
            total_read: !unread ? Number(conversationData?.unread_messages_count) : 0,
        });
    };

    const isConversationUnread = conversationData.unread || Number(conversationData.unread_messages_count) > 0;

    const data = [
        {
            name: "Call",
            icon: phone,
            disabled: true,
            popOver: null,
            action: () => { }
        },
        {
            name: "Assign",
            icon: assign,
            disabled: false,
            popOver: null,
            action: () => {
                if (selectedConversation) {
                    setIsAssignConversation(true);
                }
            }
        },
        {
            name: conversationData.resolved ? "Unresolve" : "Resolve",
            icon: conversationData.resolved ? <RxCrossCircled style={ImageStyle} /> : resolve,
            popOver: null,
            action: () => {
                if (selectedConversation && conversationData) {
                    updateConversation({
                        did: conversationData.did,
                        conversation_id: conversationData.id,
                        resolved_at: conversationData.resolved_at !== null ? null : new Date()
                    });
                }
            }
        },
        {
            name: "Contact",
            icon: newContact,
            disabled: isGroupConversation,
            popOver: (
                <div>
                    <p
                        style={
                            contacts &&
                                contacts.some(contact => contact.phones.some(phone => phone.phone_number === directParticipant))
                                ? { cursor: "not-allowed", color: "gray" }
                                : { cursor: "pointer" }
                        }
                        onClick={() => {
                            if (
                                contacts &&
                                contacts.some(contact =>
                                    contact.phones.some(phone => phone.phone_number === directParticipant)
                                )
                            )
                                return;
                            setAddContactModal(true);
                        }}
                    >
                        New Contact
                    </p>
                    <p
                        style={
                            contacts.some(contact => contact.phones.some(phone => phone.phone_number === directParticipant))
                                ? { cursor: "pointer" }
                                : { cursor: "not-allowed", color: "gray" }
                        }
                        onClick={() => {
                            if (
                                contacts &&
                                contacts.some(contact =>
                                    contact.phones.some(phone => phone.phone_number === directParticipant)
                                )
                            ) {
                                let contact = contacts.find(contact =>
                                    contact.phones.some(phone => phone.phone_number === directParticipant)
                                );
                                setExistingContactModal(true);
                                if (contact) {
                                    setEditData(contact);
                                }
                            }
                        }}
                    >
                        Edit Contact
                    </p>
                </div>
            ),
            action: () => { }
        },
        {
            name: "Download",
            icon: download,
            disabled: true,
            popOver: null,
            action: () => { }
        },
        {
            name: "Block Number",
            icon: blockNumber,
            disabled: true,
            popOver: null,
            action: () => { }
        },
        {
            name: `Mark as ${isConversationUnread ? "Read" : "Unread"}`,
            icon: markAsUnread,

            popOver: null,
            action: () => MarkAsUnread(!isConversationUnread)
        },
        {
            name: "Delete",
            icon: deleteIcon,
            disabled: true,
            popOver: null,
            action: () => {
                if (selectedConversation) {
                }
            }
        }
    ];

    return (
        <Flex style={BoxStyle} vertical={true}>
            {addContactModal && (
                <AddContactModal
                    initialNumber={directParticipant}
                    setIsModalOpen={setAddContactModal}
                    isModalOpen={addContactModal}
                />
            )}
            {existingContactModal && editData && (
                <ExistingContactModal setIsModalOpen={setExistingContactModal} isModalOpen={existingContactModal} editData={editData} />
            )}
            {isAssignConversation && (
                <ModalWrapper title={"Assign"} setIsModalOpen={setIsAssignConversation} isModalOpen={isAssignConversation}>
                    <UsersList
                        updateConversation={updateConversation}
                        setIsModalOpen={setIsAssignConversation}
                        conversation={selectedConversation}
                    />
                </ModalWrapper>
            )}

            {data.map((item, index) =>
                item.popOver ? (
                    <Popover placement="left" content={item.popOver} key={index}>
                        <Flex
                            style={{
                                ...ContentWrapper,
                                opacity: item.disabled ? "0.3" : 1,
                                cursor: item.disabled ? "not-allowed" : "pointer"
                            }}
                            onClick={item.disabled ? () => { } : item.action}
                            key={index}
                            vertical={true}
                        >
                            <Image style={ImageStyle} preview={false} src={item.icon} alt={item.name} />
                            <Text style={PhoneTextStyle}>{item.name}</Text>
                        </Flex>
                    </Popover>
                ) : (
                    <Flex
                        style={{
                            ...ContentWrapper,
                            opacity: item.disabled ? "0.3" : 1,
                            cursor: item.disabled ? "not-allowed" : "pointer"
                        }}
                        onClick={item.disabled ? () => { } : item.action}
                        key={index}
                        vertical={true}
                    >
                        {typeof item.icon === "string" ? (
                            <Image style={ImageStyle} preview={false} src={item.icon} alt={item.name} />
                        ) : (
                            item.icon
                        )}
                        <Text style={PhoneTextStyle}>{item.name}</Text>
                    </Flex>
                )
            )}
        </Flex>
    );
};

export default ChatSideBar;
